module.exports = __webpack_public_path__ + "img/news_head_2.da82e061.jpg";